// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PSCt","footer":"styles_footer__CS5Rd"};